import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    paddingLeft: 2,
    paddingRight: 2,
    fontSize: 16,
    backgroundColor: "rgb(255,229,100)",
  },
}));

function InlineCode(props: any) {
  const classes = useStyles();

  return <code className={classes.root} children={props.children} />;
}

export default InlineCode;
